import React from 'react';
import './index.scss';

const LoadingAnimation = () => (
  <div className="loading-animation-container">
    <div className="loading-animation-content">
      <img
        src="/panda_logo.jpg"
        alt="Loading"
        className="loading-animation-logo"
      />
      <div className="loading-animation-spinner" />
    </div>
  </div>
);

export default LoadingAnimation;
